export default "__VITE_ASSET__ClhJKe1Y__"